import React from 'react';

export default class Modal extends React.Component {
	constructor(){
		super();
	}
	render(){
		let modalID = Math.random()*999 + "modal";
		return (<div style={{...this.props.divStyle}}>
				<a href="#" data-toggle="modal" data-target=".bs-example-modal-lg" style={{...this.props.toggleStyle}}>
        	{
        		this.props.toggleButton ? 
        			this.props.toggleButton()
        		: <button>Toggle</button>
        	}                        
        </a>
				
				<div className="modal fade bs-example-modal-lg" ref="imgModal" tabIndex="-1" role="dialog" aria-hidden="true" style={{"display": "none"}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">

              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
                </button>
                <h4 className="modal-title" id="myModalLabel2">{this.props.title}</h4>
              </div>
              <div className="modal-body" id={modalID} ref="modalBody" style={{"color": "#000"}}>
                {
                	this.props.content ?
                		this.props.content()
                	: null
                }
              </div>
              <div className="modal-footer">
              	{
              		this.props.customBtn ? this.props.customBtn(modalID) : null
              	}
                <button type="button" className="btn btn-default" data-dismiss="modal">Luk</button>
              </div>

            </div>
          </div>
        </div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.js